import { FormSwitcher } from '@component/form-switcher/form-switcher';
import { Form } from '@form/common.style';
import { BaseFormInterface } from '@interface/form/base-form.interface';

export const IntegrationAuthForm = ({ form }: BaseFormInterface) => (
  <Form form={form}>
    <Form.Item label='Enable' name='enabled' rules={[{ required: true }]}>
      <FormSwitcher form={form} name='enabled' />
    </Form.Item>
  </Form>
);
